import { render, staticRenderFns } from "./StatsOffers.vue?vue&type=template&id=74d3c6ca"
import script from "./StatsOffers.vue?vue&type=script&lang=ts"
export * from "./StatsOffers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports